import type { ThemeConfig } from 'antd';

// ============================================================
// HV-TaskFlow — 1Office style theme
// Primary: #6699CC  ·  Font: Arial
// Light content + dark navy sidebar
// ============================================================

const PRIMARY = '#6699CC';
const PRIMARY_HOVER = '#85B2DD';
const PRIMARY_ACTIVE = '#4D80B3';
const PRIMARY_SOFT = '#e8f1f9';

// Content area — light như 1office
const BG_LAYOUT = '#f4f6f9';
const BG_CONTAINER = '#ffffff';
const BG_ELEVATED = '#fafbfc';
const BG_SPOTLIGHT = '#f0f4f8';

// Sidebar — navy đậm như 1office
const SIDEBAR_BG = '#2d3e52';
const SIDEBAR_HOVER = '#3d4f65';
const SIDEBAR_ACTIVE = '#6699CC';

// Text
const TEXT = '#2e3440';
const TEXT_SECONDARY = '#5b6875';
const TEXT_TERTIARY = '#8a95a5';
const BORDER = '#e1e5eb';

const FONT = 'Arial, sans-serif';

export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: PRIMARY,
    colorPrimaryHover: PRIMARY_HOVER,
    colorPrimaryActive: PRIMARY_ACTIVE,
    colorPrimaryBg: PRIMARY_SOFT,
    colorPrimaryBgHover: '#d4e4f2',
    colorPrimaryBorder: PRIMARY,

    colorLink: PRIMARY,
    colorLinkHover: PRIMARY_HOVER,
    colorLinkActive: PRIMARY_ACTIVE,

    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: PRIMARY,

    colorBgLayout: BG_LAYOUT,
    colorBgContainer: BG_CONTAINER,
    colorBgElevated: BG_CONTAINER,

    colorText: TEXT,
    colorTextSecondary: TEXT_SECONDARY,
    colorTextTertiary: TEXT_TERTIARY,
    colorTextQuaternary: '#a5b0c0',

    colorBorder: BORDER,
    colorBorderSecondary: '#eceef1',

    borderRadius: 6,
    fontFamily: FONT,
    fontSize: 13,
  },
  components: {
    Layout: {
      headerBg: BG_CONTAINER,
      headerHeight: 56,
      siderBg: SIDEBAR_BG,
      bodyBg: BG_LAYOUT,
      footerBg: BG_CONTAINER,
    },
    Menu: {
      // Sidebar menu: dark navy
      darkItemBg: 'transparent',
      darkItemColor: '#c5ccd6',
      darkItemHoverBg: SIDEBAR_HOVER,
      darkItemHoverColor: '#ffffff',
      darkItemSelectedBg: SIDEBAR_ACTIVE,
      darkItemSelectedColor: '#ffffff',
      darkSubMenuItemBg: 'transparent',
      // Light menu (dropdown etc)
      itemBg: 'transparent',
      itemSelectedBg: PRIMARY_SOFT,
      itemSelectedColor: PRIMARY,
      itemHoverBg: BG_SPOTLIGHT,
    },
    Button: {
      fontWeight: 500,
      primaryShadow: 'none',
    },
    Table: {
      headerBg: BG_ELEVATED,
      headerColor: TEXT_SECONDARY,
      rowHoverBg: BG_SPOTLIGHT,
      colorBgContainer: BG_CONTAINER,
      borderColor: BORDER,
    },
    Card: {
      borderRadiusLG: 6,
      colorBgContainer: BG_CONTAINER,
    },
    Tag: {
      defaultBg: BG_ELEVATED,
      defaultColor: TEXT_SECONDARY,
    },
    Modal: {
      contentBg: BG_CONTAINER,
      headerBg: BG_CONTAINER,
      footerBg: BG_CONTAINER,
    },
    Input: {
      colorBgContainer: BG_CONTAINER,
      activeBorderColor: PRIMARY,
      hoverBorderColor: PRIMARY_HOVER,
    },
    Select: {
      colorBgContainer: BG_CONTAINER,
      optionSelectedBg: PRIMARY_SOFT,
    },
    Tabs: {
      itemSelectedColor: PRIMARY,
      itemHoverColor: PRIMARY_HOVER,
      inkBarColor: PRIMARY,
    },
    Dropdown: {
      colorBgElevated: BG_CONTAINER,
    },
  },
};

export const THEME_VARS = {
  primary: PRIMARY,
  primaryHover: PRIMARY_HOVER,
  primaryActive: PRIMARY_ACTIVE,
  primarySoft: PRIMARY_SOFT,
  bgLayout: BG_LAYOUT,
  bgContainer: BG_CONTAINER,
  bgElevated: BG_ELEVATED,
  bgSpotlight: BG_SPOTLIGHT,
  sidebarBg: SIDEBAR_BG,
  text: TEXT,
  textSecondary: TEXT_SECONDARY,
  textTertiary: TEXT_TERTIARY,
  border: BORDER,
  fontFamily: FONT,
};
